module.exports = __webpack_public_path__ + "img/orange_069.4ea81c5b.png";